import { useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { Button } from 'react-bootstrap';
import ResponseTable from './responseTable';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner'; // Add Spinner import

function ExcelUploader(props) {
  const [file, setFile] = useState(null);
  const inputRef = useRef();

  const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const onUpload = () => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      // Use 'PO Details' if present, else first sheet
      const sheetName = workbook.SheetNames.includes(props.sheetName)
        ? props.sheetName
        : workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      if (!sheet) {
        toast.error(
          'Excel sheet is missing or undefined. Please check your file and try again.'
        );
        return;
      }
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
      props.processData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  const clearSelection = () => {
    setFile(null);
    if (inputRef.current) inputRef.current.value = '';
    props.resetData();
  };

  // Function to generate and download template Excel file
  const downloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([props.templateHeaders]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, props.sheetName);
    XLSX.writeFile(wb, props.templateName + '.xlsx');
  };

  return (
    <>
      <div className="excel-uploader-header-row">
        <span
          onClick={downloadTemplate}
          className="excel-uploader-download-link"
          tabIndex={0}
          role="button"
          aria-label="Download Excel Template"
        >
          Download Template
        </span>
      </div>
      <div>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          ref={inputRef}
        />
      </div>
      <br />
      <div className="excel-uploader-action-row">
        <Button
          onClick={onUpload}
          variant="primary"
          className="excel-uploader-save-btn"
          disabled={!file || props.isUploading}
        >
          Save
        </Button>
        <Button
          onClick={clearSelection}
          variant="secondary"
          className="excel-uploader-clear-btn"
          disabled={!file || props.isUploading}
        >
          Clear
        </Button>
      </div>
      <div className="excel-uploader-response-section">
        {props.isUploading ? (
          <div className="excel-uploader-spinner-container d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <ResponseTable response={props.response} />
        )}
      </div>
    </>
  );
}

export default ExcelUploader;
